import * as yup from 'yup';

export const schema = yup
  .object({
    des_tara: yup.string().trim().required(),
    val_tara: yup.string().required(),
  })
  .required();
